import { Link, LinkProps } from '@mui/material';
import { RestrictionCheck, useRestricted } from '@procureai/permissions-ui';
import { PropsWithChildren } from 'react';
import { Link as RouterLink } from 'react-router-dom';

export interface BaseLinkProps extends LinkProps {
  link?: {
    needs: RestrictionCheck;
    to: string;
  };
}

export const BaseLink = ({ children, link, ...props }: PropsWithChildren<BaseLinkProps>) => {
  const isAllowed = useRestricted(link?.needs);
  return link && isAllowed ? (
    <Link component={RouterLink} to={link.to} {...props}>
      {children}
    </Link>
  ) : (
    <>{children}</>
  );
};
